import {Component, OnDestroy, OnInit} from '@angular/core';
import * as PaymentActions from '../../store/payment.actions';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {Options} from '@angular-slider/ngx-slider';
import {Observable, Subscription} from 'rxjs';
import * as fromPayment from '../../store/payment.reducers';
import * as fromProfile from '../../../profile/store/profile.reducers';
import * as fromUser from '../../../user/store/user.reducers';
import {CustomStepDefinition} from '@angular-slider/ngx-slider/options';
import {ShortcutNumbersPipe} from '../../../helper/shortcut-numbers.pipe';

@Component({
    selector: 'app-pricing-time',
    templateUrl: './pricing-time.component.html',
    styleUrls: ['./pricing-time.component.scss'],
    standalone: false
})
export class PricingTimeComponent implements OnInit, OnDestroy {

  paymentState: Observable<fromPayment.State>;
  profileState: Observable<fromProfile.State>;
  userState: Observable<fromUser.State>;

  profileSubscription: Subscription;
  paymentSubscription: Subscription;

  packageCount: number;
  packageCountSteps: number[];

  followersSlider: number; // = 10000;
  options: Options = {
    floor: 0,
    ceil: 20000000,
    showTicks: true,
    showTicksValues: false,
    stepsArray: []
  };

  constructor(
    private store: Store<fromApp.AppState>,
    private shortcutNumbersPipe: ShortcutNumbersPipe
  ) {
    this.packageCountSteps = [];
  }

  ngOnInit() {
    this.paymentState = this.store.select('payment');
    this.profileState = this.store.select('profile');
    this.userState = this.store.select('user');

    this.onLoadPricing();

    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        const waitingForPricing = setInterval(() => {
          if (state.profileDetail !== null) {
            for (const i in this.options.stepsArray) {
              const value = this.options.stepsArray[i];
              const followersCount = Math.min(20000000, state.profileDetail.followed_by);
              if (followersCount <= value.value) {
                this.followersSlider = value.value;
                break;
              }
            }

          }
          if (this.options.stepsArray.length > 0) {
            clearInterval(waitingForPricing);
          }
        }, 300);

      }
    );

    this.paymentSubscription = this.store.select('payment').subscribe(
      (state: fromPayment.State) => {
        const that = this;

        if (Object.keys(state.pricingTime).length > 0) {
          this.packageCountSteps = <number[]>((Object.keys(state.pricingTime)).map(v => parseInt(v)));
          this.packageCount = this.packageCountSteps[0];

          if (Object.keys(state.pricingTime[this.packageCount]).length > 0) {
            const stepsArray = Object.keys(state.pricingTime[this.packageCount])
              .map(value => parseInt(value))
              .map(value => new class implements CustomStepDefinition {
              legend: string = that.shortcutNumbersPipe.transform(
                value
              );
              value = value;
            });

            if (this.followersSlider === undefined || stepsArray[0].value === -1) {
              this.followersSlider = stepsArray[0].value;
            }

            this.options = {
              floor: 0,
              ceil: 1000000,
              showTicks: true,
              showTicksValues: false,
              stepsArray: stepsArray
            };
          }
        }
      }
    );
  }

  setPackageCount(packageCount: number) {
    this.packageCount = packageCount;
  }

  getMinValue(value, minValue) {
    return Math.min(value, minValue);
  }

  onLoadPricing() {
    this.store.dispatch(
      new PaymentActions.GetPricingTime({
        params: {}
      })
    );
  }

  ngOnDestroy(): void {
    this.paymentSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
  }

}
